import React from 'react';
import styled from 'styled-components';

const SBodyText = styled.p`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.03em;
`;

type Props = React.HTMLAttributes<HTMLParagraphElement>;

export const BodyText = ({ className, children, ...props }: Props) => {
    return (
        <SBodyText className={className} {...props}>
            {children}
        </SBodyText>
    );
};
